import { render, staticRenderFns } from "./Driver.vue?vue&type=template&id=b2ff7042&scoped=true"
import script from "./Driver.vue?vue&type=script&lang=js"
export * from "./Driver.vue?vue&type=script&lang=js"
import style0 from "./Driver.vue?vue&type=style&index=0&id=b2ff7042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ff7042",
  null
  
)

export default component.exports